module.exports = __webpack_public_path__ + "img/mc.652986b.png";